import apiClient from "./apiClient";

export const fetchAllDocuments = async () => {
  try {
    const response = await apiClient.get("/document");
    return response.data;
  } catch (error) {
    console.error("Error fetching user documents", error);
    throw error;
  }
};

export const getDocumentByUUID = async (uuid) => {
  try {
    const response = await apiClient.get("/document/" + uuid);
    return response.data;
  } catch (error) {
    console.error("Error fetching user documents", error);
    throw error;
  }
};
